import { Grid, TextField, Button } from "@mui/material";

export default function BusSearch() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField label="From City" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="To City" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            type="date"
            label="Journey Date"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Button fullWidth sx={{ mt: 3 }} variant="contained">
        Search Bus
      </Button>
    </>
  );
}
